module.exports = "/assets/bad227efa0fbf27196bfb2865dd3ba73.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JY.png
// module id = 2651
// module chunks = 0